import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseServiceService } from 'src/app/services/base-service.service';
import { Utilities } from 'src/app/helpers/utilities';
import { UtilitiesColumns } from 'src/app/helpers/utilities-columns';
import { HelperImages } from 'src/app/helpers/helper-images';
import { HelperActions } from 'src/app/helpers/helper-actions';

@Component({
  selector: 'app-extendable-table',
  templateUrl: './extendable-table.component.html',
  styleUrls: ['./extendable-table.component.scss']
})
export class ExtendableTableComponent implements OnInit {

  @Input() Pagina: any;
  @Input() modelo: Array<any> = [];
  @Input() config: any;
  @Input() componentName: string = "";
  @Output() onActionEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  constructor(public baseService: BaseServiceService,
    public utility: Utilities,
    public utilityColumns: UtilitiesColumns,
    public helperActions: HelperActions,
    public helperImages: HelperImages) {


  }

  Validar() {
    /*   if (!this.modelo)
        this.modelo = []; */
    if (!this.modelo[this.config.ModelContainer])
      this.modelo[this.config.ModelContainer] = {};
    if (!this.modelo[this.config.ModelContainer][this.config.Name])
      this.modelo[this.config.ModelContainer][this.config.Name] = [];
  }
  ngOnInit() {

    

    this.Validar();
  }
  public Eliminar(index) {
    this.modelo[this.config.ModelContainer][this.config.Name].splice(index, 1);
  }
  public Add() {
    this.Validar();
    this.modelo[this.config.ModelContainer][this.config.Name].push({});
  }

  public OnSelectedComboBoxEmitterHandler(event) {

    this.OnSelectedComboBox(event.item, event.controlName, event.config);
  }
  public OnSelectedComboBox(item: any, controlName: string, config: any) {
    try {
      /*  this.ExcecuteFuntion(ControllerMethods.SelectedComboBox, false, { item: item, controlName: controlName, config: config });
       // this.ExecuteCascading(item, controlName, config);
       if (config.IdMetadataPage) {
         this.SetFormControlsFromMetadataPage(config.IdMetadataPage);
       }
 
       this.comboBoxManager.ExecuteCascading(item, controlName, config);
       this.ExcecuteFuntion(ControllerMethods.SelectedComboBox, true, { item: item, controlName: controlName, config: config });
       this.SetModelToControls(); */
    }
    catch (error) {
      this.utility.logger.LogError(error, null, { componentName: this.componentName, method: 'OnSelectedComboBox', controlName: controlName });
      this.utility.VerModalDanger().then(data => { });
    }
  }
}
